var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/modals/templates/composer-view.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"modal-inner-container modal-inner-container--composer ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSize"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsPadding"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsBackgroundColor"), env.opts.autoescape);
output += "\">\n    <div class=\"modal__buttons\">\n        <button class=\"modal__close-btn btn\" data-js-ui=\"close-modal\">\n            <span class=\"modal__close-btn-label\" data-auto-translate=\"true\">Close</span>\n            <span class=\"modal__close-btn-icon icon-close\"></span>\n        </button>\n        <button class=\"modal__print-btn btn\" data-js-ui=\"print-modal\">\n            <span class=\"modal__print-btn-label\" data-auto-translate=\"true\">Print</span>\n            <span class=\"modal__print-btn-icon icon-print\"></span>\n        </button>\n    </div>\n    <div class=\"container-fluid\">\n        <div class=\"row\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "jsModalImg")) {
output += "\n            <div class=\"col-sm-12 col-lg-4 order-lg-2 modal__media-container\">\n                <img class=\"modal__print-image\" src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsModalImg"), env.opts.autoescape);
output += "\">\n            </div>\n            <div class=\"col-sm-12 col-lg-8 order-lg-1\">\n            ";
;
}
else {
output += "\n            <div class=\"col-sm-12\">\n            ";
;
}
output += "\n                <div class=\"modal__text-container\">\n\n                    <span class=\"modal__subtitle style--underlined\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSubtitle"), env.opts.autoescape);
output += "\n                    </span>\n\n                    <h1 class=\"modal__title title--large\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsTitle"))), env.opts.autoescape);
output += "\n                    </h1>\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "jsStartDateTitle") || runtime.contextOrFrameLookup(context, frame, "jsStartDateText") || runtime.contextOrFrameLookup(context, frame, "jsEndDateTitle") || runtime.contextOrFrameLookup(context, frame, "jsEndDateText")) {
output += "\n                    <ul class=\"modal__list style--bolded\">\n                        <li class=\"modal__list-item\">\n                            <span class=\"modal__list-item-title\" data-auto-translate=\"true\">\n                                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsStartDateTitle"), env.opts.autoescape);
output += "\n                            </span>\n                            <span class=\"modal__list-item-text\" data-auto-translate=\"true\">\n                                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsStartDateText"), env.opts.autoescape);
output += "\n                            </span>\n                        </li>\n                        <li class=\"modal__list-item\">\n                            <span class=\"modal__list-item-title\" data-auto-translate=\"true\">\n                                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsEndDateTitle"), env.opts.autoescape);
output += "\n                            </span>\n                            <span class=\"modal__list-item-text\" data-auto-translate=\"true\">\n                                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsEndDateText"), env.opts.autoescape);
output += "\n                            </span>\n                        </li>\n                    </ul>\n                    ";
;
}
output += "\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "jsQuote")) {
output += "\n                    <blockquote class=\"modal__blockquote\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsQuote"), env.opts.autoescape);
output += "\n                    </blockquote>\n                    ";
;
}
output += "\n\n                    <div class=\"rich-text\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsText"))), env.opts.autoescape);
output += "\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/modals/templates/composer-view.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/modals/templates/composer-view.njk
// module id = 476
// module chunks = 0